let filterInstances = [];

function setupFilterStrip(root) {
  const track = root.querySelector('[data-blog-filter-track]');
  const controls = root.querySelector('[data-blog-filter-controls]');

  if (!(track instanceof HTMLElement) || !(controls instanceof HTMLElement)) {
    return { destroy() {} };
  }

  const prevButton = controls.querySelector('[data-direction="-1"]');
  const nextButton = controls.querySelector('[data-direction="1"]');

  if (!(prevButton instanceof HTMLButtonElement) || !(nextButton instanceof HTMLButtonElement)) {
    return { destroy() {} };
  }

  const getStep = () => Math.max(220, Math.round(track.clientWidth * 0.66));

  const updateControls = () => {
    const maxScrollLeft = Math.max(0, track.scrollWidth - track.clientWidth);
    const hasOverflow = maxScrollLeft > 4;
    controls.classList.toggle('is-hidden', !hasOverflow);

    const canScrollLeft = hasOverflow && track.scrollLeft > 2;
    const canScrollRight = hasOverflow && track.scrollLeft < maxScrollLeft - 2;

    prevButton.disabled = !canScrollLeft;
    nextButton.disabled = !canScrollRight;

    prevButton.classList.toggle('is-disabled', !canScrollLeft);
    nextButton.classList.toggle('is-disabled', !canScrollRight);
  };

  const handlePrevClick = () => {
    track.scrollBy({ left: -getStep(), behavior: 'smooth' });
  };

  const handleNextClick = () => {
    track.scrollBy({ left: getStep(), behavior: 'smooth' });
  };

  const handleTrackScroll = () => {
    updateControls();
  };

  const handleResize = () => {
    updateControls();
  };

  prevButton.addEventListener('click', handlePrevClick);
  nextButton.addEventListener('click', handleNextClick);
  track.addEventListener('scroll', handleTrackScroll, { passive: true });
  window.addEventListener('resize', handleResize);

  const activeFilter = track.querySelector('.blog-insights-filter.is-active');
  if (activeFilter instanceof HTMLElement) {
    activeFilter.scrollIntoView({ block: 'nearest', inline: 'center' });
  }

  updateControls();

  return {
    destroy() {
      prevButton.removeEventListener('click', handlePrevClick);
      nextButton.removeEventListener('click', handleNextClick);
      track.removeEventListener('scroll', handleTrackScroll);
      window.removeEventListener('resize', handleResize);
    },
  };
}

function destroyBlogFilters() {
  filterInstances.forEach((instance) => instance.destroy());
  filterInstances = [];
}

function initBlogFilters() {
  destroyBlogFilters();

  const strips = Array.from(document.querySelectorAll('.blog-insights-filter-wrap'));
  if (!strips.length) {
    return;
  }

  filterInstances = strips.map((strip) => setupFilterStrip(strip));
}

initBlogFilters();
document.addEventListener('turbo:load', initBlogFilters);
document.addEventListener('turbo:before-cache', destroyBlogFilters);
